@import '@fontsource/bricolage-grotesque/400.css';
@import '@fontsource/bricolage-grotesque/500.css';
@import '@fontsource/bricolage-grotesque/600.css';
@import '@fontsource/bricolage-grotesque/700.css';
@import '@fontsource/jetbrains-mono/400.css';
@import '@fontsource/jetbrains-mono/500.css';
@import './tokens.css';

*, *::before, *::after { box-sizing: border-box; }

html, body, #raiz { height: 100%; }

body {
  margin: 0;
  padding: 0;
  background: var(--cor-fundo);
  color: var(--cor-tinta-1);
  font-family: var(--fonte-ui);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/* numero e kicker em mono (F3) */
.mono, .kicker, [data-numero] { font-family: var(--fonte-mono); }

a { color: inherit; text-decoration: none; }
button { font: inherit; color: inherit; }
img { max-width: 100%; }
[hidden] { display: none !important; }

:focus-visible {
  outline: 2px solid var(--cor-acento-forte);
  outline-offset: 2px;
}

/* mobile sem scroll horizontal (regra geral da spec) */
html, body { overflow-x: hidden; }

::selection { background: var(--cor-acento-tenue); }

::-webkit-scrollbar { width: 10px; height: 10px; }
::-webkit-scrollbar-track { background: var(--cor-sup-1); }
::-webkit-scrollbar-thumb {
  background: var(--cor-sup-3);
  border-radius: var(--raio-1);
}
